// JSON route manifest rendered by renderRouteManifest.tsx (copied verbatim
// from pinpointedu). Shape only is inherited from productShellRouteManifest;
// contents are new per §3 of the frontend proposal. Guards are wrapper
// components keyed by name (ProtectedRoute).
//
// /accounts/day/:date and /accounts/trend are declared AHEAD of
// /accounts/:accountId so the static segments win over the dynamic one --
// routeManifest.test.ts asserts this ordering.
import type { RouteManifestNode } from './renderRouteManifest';

const routeManifest: RouteManifestNode[] = [
  { id: 'login', path: '/login', component: 'LoginPage', guard: 'none' },
  { id: 'callback-failure', path: '/auth/callback-error', component: 'RouteRecoveryScreen', guard: 'none' },
  { id: 'unavailable', path: '/unavailable', component: 'RouteRecoveryScreen', guard: 'none' },
  { id: 'offline', path: '/offline', component: 'RouteRecoveryScreen', guard: 'none' },
  { id: 'root-redirect', path: '/', component: 'RootRedirect', guard: 'ProtectedRoute' },
  { id: 'connect', path: '/connect', component: 'ConnectPage', guard: 'ProtectedRoute' },
  { id: 'accounts', path: '/accounts', component: 'AccountsPage', guard: 'ProtectedRoute' },
  { id: 'accounts-day', path: '/accounts/day/:date', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'accounts-trend', path: '/accounts/trend', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'account-detail', path: '/accounts/:accountId', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'activity', path: '/transactions', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'inbox', path: '/transactions/inbox', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'spend-by-category', path: '/transactions/categories', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  // NEW route (execution plan §3): drawn as a first-class tab on all three
  // bands and a sidebar link on desktop. Declared here, ahead of the dynamic
  // /transactions/item/:transactionId sibling below.
  { id: 'spend-by-merchant', path: '/transactions/merchants', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  // PARAM RENAME (execution plan §3, §9.10): the design's detail is a
  // transaction with N line items and a split editor
  // (GET /api/transactions/{transaction_id}), not a single line item.
  { id: 'activity-item', path: '/transactions/item/:transactionId', component: 'NotBuiltYetScreen', guard: 'ProtectedRoute' },
  { id: 'business-year', path: '/business', component: 'BusinessPage', guard: 'ProtectedRoute' },
  { id: 'rules', path: '/business/conditions', component: 'ConditionsPage', guard: 'ProtectedRoute' },
  { id: 'export-review', path: '/business/export', component: 'ExportPage', guard: 'ProtectedRoute' },
  { id: 'event', path: '/events/:eventId', component: 'EventPage', guard: 'ProtectedRoute' },
  { id: 'settings', path: '/settings', component: 'SettingsPage', guard: 'ProtectedRoute' },
  { id: 'not-found', path: '*', component: 'RouteRecoveryScreen', guard: 'none' },
];

export default routeManifest;
